<template>
  <div class="bottom-box flex-row justify-center">
    <div class="img-box flex-column">
      <div class="flex-row flex-between follow-us">
        <img class="logo-img" src="https://cdn.rockysports.cn/pilognew-img.png">

        <div class="flex-row">
          <div class="flex-column">
            <template v-for="item in navMenuList">
              <router-link class="bottom-router-left" :to="item.path">
                {{item.name}}
              </router-link>
            </template>
          </div>
          <div class="line-between"></div>
          <div class="flex-column">
            <div class="bottom-router-right" style="color: #999999;">友情链接</div>
            <template v-for="item in linkList">
              <div class="bottom-router-right link-con" @click="goLink(item.path)">{{ item.name }}</div>
            </template>
          </div>
          <div class="line-between"></div>
          <div class="flex-column align-center code-con">
            <img class="code-img" src="@/assets/images/contact-us.jpg" />
            联系我们
          </div>
        </div>
      </div>
      <div class="flex-row justify-center align-center reference">
        <div class="flex-row align-center">
          <img class="police-img" src="@/assets/images/police-img.png" />
          鲁公网安备37060202001242号 鲁ICP备2021006226号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bottom',
    data() {
      return {
        navMenuList: [
          // {id: 1, name: '首页', path: '/index'},
          {id: 2, name: '赛事', path: '/game'},
          {id: 3, name: '选手', path: '/player'},
          {id: 4, name: '政策资讯', path: '/news'},
          // {id: 5, name: '积分说明', path: '/describe'},
        ],
        linkList: [
          {name: '中国登山协会官方网站', path: 'https://www.cmasports.cn/'},
          {name: '微步赛事服务平台', path: 'https://admin.weibu.vip/admin/login'},
        ]
      }
    },
    watch:{
      '$route':{
        handler(e){
        },
        immediate: true
      }
    },
    created() {
    },
    methods: {
      // 友情链接跳转
      goLink(href) {
        window.open(href,'_blank');
      }
    }
  }
</script>

<style lang="less" scoped>
  .bottom-box{
    width: 100%;
    min-width: 1280px;
     height: 325px;
    background-color: #1A1F23;
    position: relative;
  }
  .img-box{
    width: 1280px;
    margin: 0 auto;
    display: flex;
    overflow: hidden;
    color: #ffffff;
  }

  .logo-img{
    width: 58px;
    height: 58px;
    margin-top: 33px;
  }

  .line-between{
    width: 0px;
    height: 60px;
    border: 1px solid #333333;
    margin-right: 60px;
    margin-top: 10px;
  }

  .bottom-router-left{
    margin-right: 60px;
    margin-bottom: 20px;
  }

  .bottom-router-right{
    margin-right: 60px;
    margin-bottom: 20px;
  }

  .link-con{
    cursor: pointer;
  }

  .follow-us{
    position: relative;
    padding: 40px 0;

    &:after{
      content: '';
      width: 100%;
      height: 1px;
      background-color: #666666;
      position: absolute;
      bottom: 0px;
    }
  }

  .code-con{
    margin-right: 40px;

    .code-img{
      width: 120px;
      height: 120px;
      margin-bottom: 12px;
    }
  }

  .reference{
    width: 100%;
    flex: 1;

    .police-img{
      width: 21px;
      height: 21px;
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 1100px) {
    .bottom-box{
      min-width: unset;
      .img-box{
        width: 100%;
        margin: 0 auto;
        display: flex;
        overflow: hidden;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue